<template>
  <LoadingSpinner :loading="loading"> </LoadingSpinner>

  <div class="container mt-4">
    <div style="max-width:597px">
        <h3>Legg til melding</h3>
        <p class="mt-4">Velg perioden meldingen skal vises til gjester i nettbutikken.</p>

        <div v-if="hasMultiLocations()" class="select-location-box mt-4">
          <span class="ingredient-title">Velg avdeling</span>
          <select class="form-select" v-model="locationId">
            <option v-for="(location, index) in locations" :key="index" :value="location.id">{{ location.name }}</option>
          </select>
        </div>

        <SelectDate ref="selectDateFrom" label="Vis fra og med dato"/>
        <SelectDate ref="selectDateTo" label="Vis til og med dato"/>
        <div class="mb-5">
          <span>Melding som skal vises til gjester</span>
          <input type='text' id="message" class="form-control" placeholder="F.eks. Vi er åpen 17. mai." v-model="message" />

          <div v-if="looksLikeClosingDays" class="alert alert-warning mt-3 mb-0" role="alert">
            Det ser ut som meldingen gjelder <strong>stengte dager</strong>. En melding vises kun som informasjon på forsiden og stenger ikke for bestilling.
            <a href="#" class="alert-link" @click.prevent="goToClosingDays">Registrer stengte dager også</a>.
          </div>
        </div>

        <hr/>
        <button v-if="activateSaveButton" type="button" class="bo_btn" @click="save"> Lagre </button>
        <button v-else type="button" class="bo_btn" @click="save" disabled="true"> Lagre </button>
      </div>

      <ConfirmDialogue ref="confirmDialogue"/>
  </div>
</template>

<script>
import LoadingSpinner from "@/components/other/LoadingSpinner";
import SelectDate from "@/components/other/SelectDate";
import ConfirmDialogue from "@/components/other/ConfirmDialogue";
import MerchantUtil from "@/util/MerchantUtil";
import SettingsService from "@/services/settings/SettingsService";
import moment from "moment";
import LocationUtil from "@/util/LocationUtil";
import LocationService from "@/services/location/LocationService";

export default {
    components: {LoadingSpinner, SelectDate, ConfirmDialogue},
    data() {
      return {
        loading: false,
        locationId: '',
        locations: [],
        message: ''
      };
    },
    computed: {
      activateSaveButton(){
        if(this.message.length > 0){
          return true;
        } else {
          return false;
        }
      },
      looksLikeClosingDays(){
        // Keyword-based detection of messages that are about closed days.
        // Extend the list if merchants use other phrasings.
        const text = (this.message || '').toLowerCase();
        return ['steng', 'stengt', 'stengte', 'stenger', 'ikke åpen', 'closed'].some(keyword => text.includes(keyword));
      }
    },
    mounted() {
      LocationService.listLocations().then(
          (response) => {
            this.locations = response.data;
            this.locationId = this.locations.length ? this.locations[0].id : '';
          },
          (error) => {
            console.log(error);
          }
      );
    },
    methods: {
      hasMultiLocations(){
        return LocationUtil.hasMultiLocations();
      },
      async save(){
        if(this.looksLikeClosingDays){
          const registerClosingDays = await this.$refs.confirmDialogue.show({
            title: 'Gjelder meldingen stengte dager?',
            message: 'Det ser ut som denne meldingen handler om stengte dager.<br/><br/>' +
                'En melding vises kun som informasjon på forsiden i nettbutikken — den stenger ikke for bestilling. ' +
                'Vil du registrere stengte dager også?',
            okButton: 'Ja, registrer stengte dager',
            cancelButton: 'Nei, bare lagre meldingen'
          });
          if(registerClosingDays){
            this.goToClosingDays();
            return;
          }
        }
        this.doSave();
      },
      doSave(){
        this.loading = true;

        let displayFromDate =  this.$refs.selectDateFrom.getSelectedDate();
        let displayToDate =  this.$refs.selectDateTo.getSelectedDate();
        let announcement = {
          type: "announcement",
          merchant: MerchantUtil.getMerchant(),
          locationId: this.locationId,
          displayFromDate: (moment(displayFromDate)).format('YYYY-MM-DD'),
          displayToDate: (moment(displayToDate)).format('YYYY-MM-DD'),
          message: this.message
        };
        this.createAnnouncement(announcement);
      },
      goToClosingDays(){
        // Carry the announcement's dates, message and location over to the
        // closing-days form, and pre-enable "show message to guests" there so
        // the merchant registers both in one place (no duplicate announcement).
        this.$router.push({
          name: 'closingDaysCreate',
          query: {
            prefillFromAnnouncement: '1',
            message: this.message,
            locationId: this.locationId,
            fromDate: this.$refs.selectDateFrom.getSelectedDate(),
            toDate: this.$refs.selectDateTo.getSelectedDate()
          }
        });
      },
      createAnnouncement(announcement){
        SettingsService.createAnnouncement(announcement).then(
            (response) => {
              let documentId = response.data;
              if(documentId){
                this.$router.push({ path: 'announcements' });
              } else {
                console.log("Creating announcement failed");
              }
              this.loading = false;
            },
            (error) => {
              console.log(error);
            }
        );
      }
    }
  };
</script>
